// extracted by mini-css-extract-plugin
module.exports = {" _key":"dojo2-todo-mvc-kitchensink/todoList","todoList":"todoList-m__todoList__52e415_yRMt","cardList":"todoList-m__cardList__52e4151dkaX"};